"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatreonIcon = void 0;

var _element = require("@wordpress/element");

var _primitives = require("@wordpress/primitives");

/**
 * WordPress dependencies
 */
const PatreonIcon = () => (0, _element.createElement)(_primitives.SVG, {
  width: "24",
  height: "24",
  viewBox: "0 0 569 546",
  version: "1.1"
}, (0, _element.createElement)(_primitives.Circle, {
  cx: "363",
  cy: "205",
  r: "205"
}), (0, _element.createElement)(_primitives.Rect, {
  width: "100",
  height: "546",
  x: "0",
  y: "0"
}));

exports.PatreonIcon = PatreonIcon;
//# sourceMappingURL=patreon.js.map